import { render, staticRenderFns } from "./ProductMap.vue?vue&type=template&id=8ce98bb6&scoped=true&"
import script from "./ProductMap.vue?vue&type=script&lang=js&"
export * from "./ProductMap.vue?vue&type=script&lang=js&"
import style0 from "./ProductMap.vue?vue&type=style&index=0&id=8ce98bb6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ce98bb6",
  null
  
)

export default component.exports